import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ApiResult } from "@app/shared/model/apiresult";
import { Guid } from "guid-typescript";
import { catchError, map } from 'rxjs/operators';
import { IStudentDocument } from "../model/studentdocument";
import { environment as env } from '@environments/environment'
import { throwError } from "rxjs";
import { IDocumentStore } from "../model/documentstore";

@Injectable({ providedIn: 'root' })

export class StudentDocumentService {
    constructor(private http: HttpClient) { }

    get(studentId: Guid) {
        return this.http.get<ApiResult<IStudentDocument[]>>(env.apiUrl + 'studentdocument/' + studentId);
    }
    getById(Id: Guid) {
        return this.http.get<ApiResult<IStudentDocument>>(env.apiUrl + 'studentdocument/GetById/' + Id);
    }
    getDocumentsById(studentDocumentId: Guid) {
        return this.http.get<ApiResult<IDocumentStore[]>>(env.apiUrl + 'studentdocument/GetDocumentsById/' + studentDocumentId);
    }
    post(studentDocument: IStudentDocument) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'studentdocument', studentDocument).pipe(catchError(this.handleError))
    }
    put(studentDocument: IStudentDocument) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'studentdocument', studentDocument);
    }
    delete(id: Guid) {
        return this.http.delete<ApiResult<any>>(env.apiUrl + 'studentdocument/' + id);
    }
    received(id:Guid) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'studentdocument/received/' + id,"");
    }
    fileUpload(formData: FormData) {
        const url = env.apiUrl + 'studentdocument/UploadFile';
        const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
        // POST
        return this.http.post<ApiResult<number>>(url, formData, { headers: headers })
            .pipe(map(response => response));
    }

    downloadDocument(documentId: Guid,studentId: Guid) {
        return this.http.get(env.apiUrl + 'studentdocument/downloadfile/'+studentId+'/'+documentId, {
            responseType: 'blob'
        });
    } 

    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}